import { V004Algorithm } from '../../../../Algorithm';
export class DeriveHashingKeyUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(key) {
        const hashingKey = this.crypto.sodiumCryptoKdfDeriveFromKey(key.itemsKey, V004Algorithm.PayloadKeyHashingKeySubKeyNumber, V004Algorithm.PayloadKeyHashingKeySubKeyBytes, V004Algorithm.PayloadKeyHashingKeySubKeyContext);
        return {
            key: hashingKey,
        };
    }
}
